import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { SiteContentProvider } from "./data/SiteContentContext";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SiteContentProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </SiteContentProvider>
  </StrictMode>,
);
